import { Box } from '@mui/material';
import PayPalLogo from 'renderer/assets/payment-processors/paypal.svg';
import StripeLogo from 'renderer/assets/payment-processors/stripe.svg';
import BraintreeLogo from 'renderer/assets/payment-processors/braintree.svg';
import type { TransactionProcessor } from '../schemas/transaction.transformer';

type TransactionProcessorIconProps = {
  processor: TransactionProcessor;
  height?: number;
};

const PROCESSOR_LOGOS: Record<
  TransactionProcessor,
  { src: string; alt: string; height: number }
> = {
  paypal: { src: PayPalLogo, alt: 'PayPal', height: 16 },
  stripe: { src: StripeLogo, alt: 'Stripe', height: 16 },
  braintree: { src: BraintreeLogo, alt: 'Braintree', height: 16 },
};

const TransactionProcessorIcon = ({
  processor,
  height,
}: TransactionProcessorIconProps) => {
  const logo = PROCESSOR_LOGOS[processor];
  const logoHeight = height ?? logo.height;

  return (
    <Box
      component="img"
      src={logo.src}
      alt={logo.alt}
      sx={{
        height: logoHeight,
        width: 'auto',
        display: 'block',
        objectFit: 'contain',
      }}
    />
  );
};

export default TransactionProcessorIcon;
